// extracted by mini-css-extract-plugin
module.exports = {"head":"ShopList_head__16eig","title":"ShopList_title__2eDa3","formwid":"ShopList_formwid__3aqox","tagBox":"ShopList_tagBox__29uC6","outer":"ShopList_outer__1grZR"};